.container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  position: relative;

  justify-content: center;
  height: 30rem;

  img {
    max-height: 18rem;
  }

  transform: translateX(-9rem);

  .text {
    width: fit-content;
    transform: translate(25.125rem);
  }

  .text1 {
    font-family: 'Preahvihear';
    font-style: normal;
    font-weight: 400;
    font-size: 1.188rem;

    letter-spacing: -0.031rem;

    transform: translate(-3.125rem, -3.125rem);
    svg {
      position: absolute;
      z-index: -1;

      transform: translate(-5.313rem, 1.375rem);
    }
  }

  .text2 {
    width: fit-content;
    text-decoration: underline;

    font-family: 'Preahvihear';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
  }
  .text3 {
    width: fit-content;

    font-family: 'Preahvihear';
    font-style: normal;
    font-weight: 400;
    font-size: 3.125rem;
    line-height: 3.938rem;

    letter-spacing: 0.02em;
    svg {
      position: absolute;
      transform: translate(-1.125rem);
      z-index: -1;
    }
  }

  .text4 {
    width: fit-content;

    font-family: 'Preahvihear';
    font-style: normal;
    font-weight: 200;
    font-size: 0.688rem;
    line-height: 1.25rem;

    letter-spacing: 0.02em;
  }
}

.image {
  display: flex;
  flex-direction: column;
  position: absolute;

  height: 26.938rem;
  width: 24.063rem;

  white-space: nowrap;
  align-items: center;
  justify-content: center;

  transform: translate(2.5rem, 2.75rem);

  background: radial-gradient(
    50% 50% at 50% 50%,
    #763cac 0%,
    rgba(50, 15, 133, 0) 100%
  );
}
